import { AlertCircle, AlertTriangle, CheckCircle2, Info } from "lucide-react";

import { FormattedCopyMarkdown } from "@/components/form-copy/FormattedCopyMarkdown";
import { cn } from "@/lib/utils";

import type { QuestionRendererProps } from "../types";

const TONE_STYLES = {
  info: "border-blue-300/60 bg-blue-50/60 text-blue-900",
  success: "border-emerald-300/60 bg-emerald-50/60 text-emerald-900",
  warning: "border-amber-300/60 bg-amber-50/60 text-amber-900",
  error: "border-rose-300/60 bg-rose-50/60 text-rose-900",
} as const;

const TONE_ICONS = {
  info: Info,
  success: CheckCircle2,
  warning: AlertTriangle,
  error: AlertCircle,
} as const;

export const CalloutQuestion = ({ question }: QuestionRendererProps<null>) => {
  if (question.type !== "callout") {
    return null;
  }

  const tone = question.tone ?? "info";
  const Icon = TONE_ICONS[tone];

  return (
    <div className={cn("rounded-xl border px-4 py-3", TONE_STYLES[tone])}>
      <div className="flex items-start gap-2">
        <Icon className="mt-0.5 h-4 w-4 shrink-0" />
        <FormattedCopyMarkdown
          content={question.markdown}
          variant="body"
          className="text-sm"
        />
      </div>
    </div>
  );
};
